"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _uiwidgetsCommon = require("uiwidgets-common");

var _ParseUtils = require("./ParseUtils");

var _DateComponentOrder = require("./DateComponentOrder");

var regx = /([^\s\.\/\\,-]+)[\s\.\/\\,-]+([^\s\.\/\\,-]+)[\s\.\/\\,-]+([^\s\.\/\\,-]+)/;

/**
 * Parse a date.
 *
 * @param s {String} the string to parse.
 * @param [opts] {Object} the configuration object.
 *   @param opts.dateComponentOrder {Array} an array containing the preferred date component order ['d', 'm', 'y']
 */

exports.default = function (s, opts) {
    // trim the string before doing anything.
    s && (s = s.trim().toLowerCase());

    // no string / empty string, null value.
    if (!s) {
        return null;
    }

    opts || (opts = {});
    var dateComponentOrder = opts.dateComponentOrder || (0, _DateComponentOrder.componentOrder)();

    // attempt to parse
    var match = regx.exec(s);
    if (!match) {
        return undefined;
    }

    var values = match.slice(1);
    var result = {};

    // some stuff sticks out like a sore thumb, so we'll do an initial pass and strip them out first.
    for (var f = 0; f < 3; f++) {
        // month, possibly being wordy, may stand out amongst the other components.
        var monthValue = (0, _ParseUtils.parseMonthWord)(values[f]);
        if (!(0, _uiwidgetsCommon.isUndefined)(monthValue)) {
            // null the value so we don't look at it again.
            values[f] = null;
            result.m = monthValue;
            break;
        }

        // next, we'll look for the day with an ordinal postfix, that would make the day stand out from a 2 digit year
        // and any numeric month.
        var dayValue = (0, _ParseUtils.parseDayWithOrdinal)(values[f]);
        if (dayValue) {
            values[f] = null;
            result.d = dayValue;
            break;
        }
    }

    // we have day and month, but no year?
    if (result.d !== undefined && result.m !== undefined) {
        // we have both the day and month, so the remaining value must be year.
        var yearValue = (0, _ParseUtils.parseYear)(values.find(function (value) {
            return value !== null;
        }));
        yearValue && (result.y = yearValue);
    }

    // we have month, but no day or year?
    if (result.m !== undefined && result.d === undefined && result.y === undefined) {
        var remaining = values.reduce(function (results, result) {
            if (result !== null) {
                results.push((0, _ParseUtils.parseNumber)(result));
            }
            return results;
        }, []);

        var largestNumber = Math.max.apply(undefined, remaining);
        if (largestNumber > 31) {
            result.y = (0, _ParseUtils.parseYear)(largestNumber);
            result.d = Math.min.apply(undefined, remaining);
        } else {
            // we have no means to figuring out which of these numbers is the year, so we'll fall back to looking
            // at the preferred component order.
            if (dateComponentOrder.indexOf("d") < dateComponentOrder.indexOf("y")) {
                result.d = (0, _ParseUtils.parseNumber)(remaining[0]);
                result.y = (0, _ParseUtils.parseYear)(remaining[1]);
            } else {
                result.d = (0, _ParseUtils.parseNumber)(remaining[1]);
                result.y = (0, _ParseUtils.parseYear)(remaining[0]);
            }
        }
    }

    // we have day, but no month or year?
    if (result.d !== undefined && result.m === undefined && result.y === undefined) {
        var _remaining = values.reduce(function (results, result) {
            if (result !== null) {
                results.push((0, _ParseUtils.parseNumber)(result));
            }
            return results;
        }, []);

        var _largestNumber = Math.max.apply(undefined, _remaining);
        if (_largestNumber > 12) {
            result.y = (0, _ParseUtils.parseYear)(_largestNumber);
            result.m = Math.min.apply(undefined, _remaining) - 1;
        } else {
            // we have no means to figuring out which of these numbers is the year, so we'll fall back to looking
            // at the preferred component order.
            if (dateComponentOrder.indexOf("m") < dateComponentOrder.indexOf("y")) {
                result.m = (0, _ParseUtils.parseNumber)(_remaining[0]);
                result.y = (0, _ParseUtils.parseYear)(_remaining[1]);
            } else {
                result.m = (0, _ParseUtils.parseNumber)(_remaining[1]);
                result.y = (0, _ParseUtils.parseYear)(_remaining[0]);
            }
        }
    }

    // we have nothing?
    if (result.d === undefined && result.m === undefined && result.y === undefined) {
        for (var _f = 0; _f < dateComponentOrder.length; _f++) {
            var component = dateComponentOrder[_f];
            var value = match[_f + 1];

            if (component === "m") {
                value = (0, _ParseUtils.parseMonth)(value);
            } else if (component === "y") {
                value = (0, _ParseUtils.parseYear)(value);
            } else if (component === "d") {
                value = (0, _ParseUtils.parseNumber)(value);
            }

            if ((0, _uiwidgetsCommon.isUndefined)(value)) {
                return undefined;
            }
            result[component] = value;
        }
    }

    return new Date(Date.UTC(result.y, result.m, result.d));
};
//# sourceMappingURL=DateParser.js.map